import businessClient from 'src/services/clients/business'
import { IMeta, IArchive } from 'src/common/interfaces/index.js'

const IArchiveResponse = { meta: IMeta, data: { list: [IArchive] } }
const IRestoreResponse = { meta: IMeta, data: { list: [Object] } }

export const archives = {
  /**
   * @param {entity_type: string, row_number: number, page: number} filter
   * @return {Promise<IArchiveResponse>}
   */
  list(filter = {}, signal) {
    return businessClient().post('settings/restore/portal/list', { filter }, { signal })
  },

  /**
   * @param {entity_type: string, id: number} filter
   * @return {Promise<IRestoreResponse>}
   *
   */
  restore(filter = {}, signal) {
    return businessClient().post('settings/restore/portal/restore', { filter }, signal)
  },
}
